import React from 'react';

export type AutoStatusToastKind = 'saving' | 'success' | 'error' | 'info';

export type AutoStatusToastState = {
  kind: AutoStatusToastKind;
  message: string;
} | null;

export function useAutoStatusToast(timeoutMs = 3000) {
  const [toastState, setToastState] = React.useState<AutoStatusToastState>(null);

  React.useEffect(() => {
    if (!toastState || toastState.kind === 'saving') return;
    const timer = window.setTimeout(() => setToastState(null), timeoutMs);
    return () => window.clearTimeout(timer);
  }, [timeoutMs, toastState]);

  const showSaving = React.useCallback((message = '저장 중입니다...') => {
    setToastState({ kind: 'saving', message });
  }, []);

  const showSuccess = React.useCallback((message = '저장되었습니다.') => {
    setToastState({ kind: 'success', message });
  }, []);

  const showError = React.useCallback((message = '저장에 실패했습니다.') => {
    setToastState({ kind: 'error', message });
  }, []);

  const showInfo = React.useCallback((message: string) => {
    setToastState({ kind: 'info', message });
  }, []);

  const clearToast = React.useCallback(() => {
    setToastState(null);
  }, []);

  return {
    toastState,
    setToastState,
    showSaving,
    showSuccess,
    showError,
    showInfo,
    clearToast,
  };
}
